import { AnalyticsDispatcher } from '../../internal/AnalyticsDispatcher';
import { withFilter as higherOrder } from '../../extenders';
function withFilter(filter) {
    return higherOrder(filter)(this);
}
AnalyticsDispatcher.prototype.withFilter = withFilter;
//# sourceMappingURL=withFilter.js.map